import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const MediumMoreOptions = ({ testId, className })=>{
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M2.72726 9.45452C3.6812 9.45452 4.45452 8.6812 4.45452 7.72726C4.45452 6.77332 3.6812 6 2.72726 6C1.77332 6 1 6.77332 1 7.72726C1 8.6812 1.77332 9.45452 2.72726 9.45452Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M7.99997 9.45452C8.95391 9.45452 9.72723 8.6812 9.72723 7.72726C9.72723 6.77332 8.95391 6 7.99997 6C7.04603 6 6.27271 6.77332 6.27271 7.72726C6.27271 8.6812 7.04603 9.45452 7.99997 9.45452Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M13.2727 9.45452C14.2266 9.45452 14.9999 8.6812 14.9999 7.72726C14.9999 6.77332 14.2266 6 13.2727 6C12.3187 6 11.5454 6.77332 11.5454 7.72726C11.5454 8.6812 12.3187 9.45452 13.2727 9.45452Z",
                fill: "currentColor"
            })
        ]
    });
};

export { MediumMoreOptions as default };
